import { Button, Card, CircularProgress, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../components';
import { getDetailAdmin, updAdmin } from '../../../redux/actions/AdminActions';
import { role } from './roleAdmin';

const EditAdmin = () => {
    const { id } = useParams();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        users_code:"",
        fullname:"",
        email_old:"",
        email:"",
        profile_pict:"",
        profile_pict_preview:"",
        profile_pict_ori:"",
        password:"",
        role:"",
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updAdmin(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const handleChangeFoto = (file, path) => {
        setParams((pref) => ({
            ...pref,
            profile_pict: file,
            profile_pict_preview: path
        }));
    };
    const getData = useCallback(() => {
        setLoading(true);
        getDetailAdmin(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        users_code:data?.users_code,
                        fullname:data?.fullname,
                        email_old:data?.email,
                        email:data?.email,
                        profile_pict:"",
                        profile_pict_preview:data?.profile_pict,
                        profile_pict_ori:data?.profile_pict_ori,
                        role:data?.users_type,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data admin, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data admin, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            users_code: id
        }));
        getData();
    }, [getData, id]);
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Admin</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <UploadImage
                                            uploadFoto={handleChangeFoto}
                                            label="Foto"
                                            preview={
                                                params?.profile_pict_preview
                                            }
                                            required={true}
                                            aspectRatio={1 / 1}
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 300 x 300 atau 1:1'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="fullname"
                                            className="mb-4"
                                        >
                                            Nama{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </InputLabel>
                                        <TextValidator
                                            id="fullname"
                                            placeholder="Nama"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="fullname"
                                            value={params.fullname || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Nama terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="email"
                                            className="mb-4"
                                        >
                                            Email{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </InputLabel>
                                        <TextValidator
                                            id="email"
                                            placeholder="Email"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="email"
                                            name="email"
                                            value={params.email || ''}
                                            validators={['required', 'isEmail']}
                                            errorMessages={[
                                                'Masukkan Email terlebih dahulu',
                                                'Email tidak valid'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="password"
                                            className="mb-4"
                                        >
                                            Password
                                        </InputLabel>
                                        <TextValidator
                                            id="password"
                                            placeholder="Password"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="password"
                                            name="password"
                                            value={params.password || ''}
                                        />
                                        <ul className="pl-3 mt-4 mb-0">
                                            <li className="text-muted">
                                                Isi password jika Anda ingin
                                                mengubah password
                                            </li>
                                        </ul>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="role"
                                            className="mb-4"
                                        >
                                            Role{' '}
                                            <span className="text-danger">
                                                *
                                            </span>
                                        </InputLabel>
                                        <Select
                                            labelId="role"
                                            value={params.role}
                                            onChange={handleChange}
                                            variant="outlined"
                                            className="w-full"
                                            name="role"
                                            displayEmpty
                                        >
                                            <MenuItem
                                                value=""
                                                selected
                                                disabled
                                            >
                                                Role
                                            </MenuItem>
                                            {role?.map((item) => (
                                                <MenuItem
                                                    value={item?.value}
                                                    key={item?.value}
                                                >
                                                    {item?.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default EditAdmin;
